import { useLocation } from "react-router-dom";
import { useExperience } from "../../context/ExperienceContext";
import { useScrollReveal } from "./useScrollReveal";

export default function GlobalScrollReveal() {
  const location = useLocation();
  const { mode } = useExperience();

  useScrollReveal(
    ".reveal-on-scroll",
    {
      triggerRatio: 0.12,
      once: true,
    },
    [location.pathname, mode]
  );

  return null;
}